import Router from "./routes/Index";
import './assets/styles/index.css'
import ThemeProvider from "./layout/provider/Theme";
const App = () => {
  return (
    <ThemeProvider>
      <Router />
    </ThemeProvider>
  );
};
export default App;
